import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from "../../scss/taxes.module.scss";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { useDispatch, useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import { PROFILE_EPOS_NOW } from "../../const/URL.const";
import { useHistory } from "react-router-dom";
import useTask from "../../hooks/useTask";
import { setMigrationDialog } from "../../actions/migrations";
import { removeDisabledRoute } from "../../actions/disabledRoutes";
import { SalesTaxSetupIcon } from "../icon/SalesTaxIcon";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from "@material-ui/icons/Close";
import { FaqLinks, getUrlBasedOnCurrentLanguage } from "../../const/faqs-links";
import {setFeesMigration, setItemsMigration} from "../../yoello-lib/modules/redux/actions/migration.actions"

const TaxSetUpDialog = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
  const isFeesNotMigrated = useSelector((state: IReduxAppState) => state.migrations.isMigrateFees);
  const isItemsNotMigrated = useSelector((state: IReduxAppState) => state.migrations.isMigrateItems);
  const isOpen = useSelector((state: IReduxAppState) => state.migrations.isOpen);

  /**call fees API */
  const { callAPI: callFees } = useAPIV2(APIExtensions.migrationsFees, { onMountDisabled: true });
  /**Call items API */
  const { callAPI: callItems } = useAPIV2(APIExtensions.migrationItems, { onMountDisabled: true });

  const { increaseDoneTasks } = useTask();

  useEffect(() => {
    if (isFeesNotMigrated || isItemsNotMigrated) {
      dispatch(setMigrationDialog(true));
    } else if (isOpen) {
      dispatch(setMigrationDialog(false));
    }
    //eslint-disable-next-line
  }, [isFeesNotMigrated, isItemsNotMigrated]);

  async function onClick() {
    setIsLoading(true);

    if (isFeesNotMigrated) {
      await callFees(HTTPMethods.POST, {
        body: {
          venue_id: venueId
        }
      })
    }
    /**If epos now navigate to the sync page */
    if (isEposNow) {
      dispatch(setMigrationDialog(false));
      history.push(PROFILE_EPOS_NOW)
      return;
    }
    if (isItemsNotMigrated) {
      await callItems(HTTPMethods.POST, {
        body: {
          venue_id: venueId
        }
      })
    }

    increaseDoneTasks();
    setIsLoading(false);
    dispatch(removeDisabledRoute("TAXES"));
    dispatch(setMigrationDialog(false));

    dispatch(setFeesMigration(false));
    dispatch(setItemsMigration(false));
  }
  return (
    <Dialog
      onClose={() => { if (!isLoading) dispatch(setMigrationDialog(false)); }}
      open={isOpen}
      className="outstanding"
    >
      <div className={Styles.taxSetup}>
        <div className={Styles.topIcon}>
          <SalesTaxSetupIcon />
        </div>
        <div className={Styles.closeIcon}>
          <CloseIcon onClick={() => { if (!isLoading) dispatch(setMigrationDialog(false)); }} />
        </div>
        <h3 className={Styles.title}>{t("taxes.taxSetUp.title")}</h3>
        <p className={Styles.intro}>
          {!isEposNow
            ? t("taxes.taxSetUp.intro")
            : t("taxes.taxSetUp.introEposnow")}
        </p>
        <p className={Styles.intro2}>{t("taxes.taxSetUp.intro2")}</p>

        <Button
          className={Styles.submit}
          variant="contained"
          color="primary"
          size="large"
          onClick={onClick}
          disabled={isLoading}
        >
          {!isEposNow
            ? t("taxes.taxSetUp.submit")
            : t("taxes.taxSetUp.submitEposnow")}
        </Button>

        {isEposNow && <div className={Styles.warning}>
          <h3 className={Styles.title}>
            <InfoOutlinedIcon className={Styles.infoIcon} />
            {t("taxes.taxSetUp.warinigTitle")}
          </h3>
          <p className={Styles.info}>{t("taxes.taxSetUp.warinigIntro")}</p>

          <Button className={Styles.submitBtn} variant="contained" target="_blank" size="large" href={(getUrlBasedOnCurrentLanguage(FaqLinks.SETUP_TAXES_EPOSNOW.key) as string)}>
            {t("taxes.taxSetUp.warinigSubmit")}
          </Button>
        </div>}
      </div>
    </Dialog>
  );
};

export default TaxSetUpDialog;
